import { searchReport } from '@/reports/searchReport';
import type { UsernameSearchRequestBody } from '@/reports/searchReport';

export interface UsernameSearchParams {
  username: string;
  'h-captcha-response'?: string;
}

// TODO add value when a specific social media is selected
export async function usernameSearch({
  username,
  'h-captcha-response': hcaptchaResponse,
}: UsernameSearchParams) {
  const body: UsernameSearchRequestBody = {
    report_type: 'username_report',
    meta: {
      username,
      report_flags: [],
    },
    'h-captcha-response': hcaptchaResponse || '',
  };

  return searchReport(body);
}
